<!--
 * @Description:
 * @Author: JDY
 * @Date: 2021-04-07 12:00:03
 * @LastEditTime: 2021-05-08 21:05:02
 * @LastEditors: JDY
-->
<template>
  <div class="edit-form">
    <a-form :form="form" @submit="handleEditPassWord">
      <a-form-item label="旧密码" :labelCol="labelCol" :wrapperCol="wrapperCol">
        <a-input
          size="large"
          type="password"
          placeholder="旧密码"
          v-decorator="['old_password', { rules: [{ required: true, message: '请输入旧密码' }] }]"
        ></a-input>
      </a-form-item>
      <a-form-item label="新密码" :labelCol="labelCol" :wrapperCol="wrapperCol">
        <a-input
          size="large"
          type="password"
          placeholder="新密码"
          v-decorator="['password', { rules: [{ required: true, message: '请输入新密码' }] }]"
        ></a-input>
      </a-form-item>
      <a-form-item label="再次输入新密码" :labelCol="labelCol" :wrapperCol="wrapperCol">
        <a-input
          size="large"
          type="password"
          placeholder="再次输入新密码"
          v-decorator="['confirm_password', { rules: [{ required: true, message: '请再次输入新密码' }] }]"
        ></a-input>
      </a-form-item>
      <a-form-item :wrapper-col="{ span: 13, offset: 7 }">
        <a-button type="primary" html-type="submit">
          修改
        </a-button>
      </a-form-item>
    </a-form>
  </div>
</template>

<script>
import { requestPut } from '@/api/api'

export default {
    name: 'EditPassWord',
    components: {},
    data () {
        return {
            id: this.$store.getters.userId,
            labelCol: {
                xs: { span: 24 },
                sm: { span: 7 }
            },
            wrapperCol: {
                xs: { span: 24 },
                sm: { span: 13 }
            },
            form: this.$form.createForm(this)
        }
    },
    methods: {
        /**
         * 修改密码
         * @params
         * @jdy
         * @10-16
         */
        handleEditPassWord (e) {
            e.preventDefault()
            const {
                form: { validateFields }
            } = this
            validateFields((errors, values) => {
                if (!errors) {
                    requestPut('/admins/users/password/' + this.id, values)
                        .then(res => {
                            this.$notification.success({
                                message: res.msg
                            })
                        })
                }
            })
        }
    }
}
</script>

<style lang="less" scoped></style>
